import FalconCloseButton from 'components/common/FalconCloseButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import useToken from '../../hooks/useToken';

const ModalActualizarPaqueteAkasiaPOS = (
    {
        idLicencia,
        akasiaPOSWebPaquetes,
        setAkasiaPOSModulosPorPaquete,
        CodigoPaqueteAkasiaPOS,
        setCodigoPaqueteAkasiaPOS,
        setIdAkasiaPOSWebPaquetes,
        setDescripcionPaqueteAkasiaPOS,
        showModalActualizarPaqueteAkasiaPOS,
        setShowModalActualizarPaqueteAkasiaPOS,
        setAkasiaPOSWebPaquetes,
        setModulosExtraVinculados
    }
) => {

    const [procesandoModal, setProcesandoModal] = useState(false);
    const [nuevoPaquete, setNuevoPaquete] = useState("");
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    /**
     * Manda a llamar el metodo para Actualizar el Paquete
     * @param {any} e
     */
    const onSubmitActualizarPaquete = async (e) => {
        e.preventDefault();

        /**Validar que no se seleccione el mismo paquete*/
        if (!nuevoPaquete) {
            showErrorToast("Es necesario que seleccione un nuevo paquete.");
            return;
        }
        if (nuevoPaquete == CodigoPaqueteAkasiaPOS) {
            showErrorToast("La licencia ya cuenta con éste paquete.");
            return;
        }

        setProcesandoModal(true);

        try {
            console.log('vNuevoPaquete:', nuevoPaquete, 'idLicencia: ', idLicencia);

        } catch (error) {
            console.error('Error al renovar paquete:', error);
        }

        const response = await fetch("/api/licencia/ActualizarPaqueteAkasiaPOS/?vNuevoPaquete=" + nuevoPaquete + "&vCodigoPaqueteAkasiaPOS=" + CodigoPaqueteAkasiaPOS + "&idLicencia=" + idLicencia, {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            console.log(data);
            if (data["table1"][0].iResponseType == 1) {

                showSuccessToast(data["table1"][0].vMessage);

                setAkasiaPOSModulosPorPaquete(data["table2"]);
                setModulosExtraVinculados(data["table4"]);
                setAkasiaPOSWebPaquetes(data["table5"]);
                //setModulosExtraVinculados(data["table6"]);

                setIdAkasiaPOSWebPaquetes(data["table3"][0].idAkasiaPOSWebPaquetes);
                setCodigoPaqueteAkasiaPOS(data["table3"][0].vCodigoPaquete);
                setDescripcionPaqueteAkasiaPOS(data["table3"][0].vDescripcionPaquete);

            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalActualizarPaqueteAkasiaPOS(false);
        setProcesandoModal(false);
    };


    return (
        showModalActualizarPaqueteAkasiaPOS &&
        <Modal
            show={showModalActualizarPaqueteAkasiaPOS}
            onHide={() => setShowModalActualizarPaqueteAkasiaPOS(false)}
            size="lg"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form noValidate onSubmit={onSubmitActualizarPaquete}>
                <Modal.Header>
                    <Modal.Title>
                        Actualizar Paquete de Licencia
                    </Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalActualizarPaqueteAkasiaPOS(false) }} />

                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Selecciona el nuevo paquete para la licencia</Form.Label>
                                <Form.Select
                                    required
                                    aria-label="Default select"
                                    onClick={(e) => setNuevoPaquete(e.target.value)}
                                >
                                    <option value="">Selecciona el paquete</option>
                                    {akasiaPOSWebPaquetes.map((pq, index) => {
                                        return (<option key={index} value={pq.vCodigoPaquete}>{pq.vDescripcionPaquete} - [{pq.vCodigoPaquete}]</option>)
                                    })}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">

                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setShowModalActualizarPaqueteAkasiaPOS(false); }} variant='danger' >Cerrar</Button>
                    {procesandoModal ? <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button> : <Button type="submit" variant='primary' >Actualizar</Button>}
                </Modal.Footer>
            </Form>
        </Modal>

    )
}

ModalActualizarPaqueteAkasiaPOS.propTypes = {
    idLicencia: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    akasiaPOSWebPaquetes: PropTypes.array,
    setAkasiaPOSModulosPorPaquete: PropTypes.func,
    CodigoPaqueteAkasiaPOS: PropTypes.string,
    setCodigoPaqueteAkasiaPOS: PropTypes.func,
    setIdAkasiaPOSWebPaquetes: PropTypes.func,
    setDescripcionPaqueteAkasiaPOS: PropTypes.func,
    showModalActualizarPaqueteAkasiaPOS: PropTypes.bool,
    setShowModalActualizarPaqueteAkasiaPOS: PropTypes.func,
    setAkasiaPOSWebPaquetes: PropTypes.func,
    setModulosExtraVinculados: PropTypes.func
};


export default ModalActualizarPaqueteAkasiaPOS;
